import { render, staticRenderFns } from "./LvScrollableBlockContent.vue?vue&type=template&id=08b1f5af"
import script from "./LvScrollableBlockContent.vue?vue&type=script&lang=js"
export * from "./LvScrollableBlockContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports